import { logger } from "../../../../lib/utils/logger/logger";

export const uploadFiles = async (
  url: string,
  frontImage: File,
  backImage: File,
): Promise<Response> => {
  logger.info(`uploading files to ${url}`);

  const body = new FormData();
  body.append("frontImage", frontImage);
  body.append("backImage", backImage);

  return fetch(url, {
    method: "POST",
    body,
  });
};
